<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <div class="content">
                <iframe src="" ref="investigationFrame" frameborder="0" id="investigationFrame" width="100%" height="700" scrolling="yes"></iframe>
            </div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { geInvestigationDetail } from '@/service/api.js'

export default {
    components: { BottomMenu },
    beforeCreate () {
        geInvestigationDetail('key='+this.$route.params.id).then(data=>{
            if (data.code !==0) {
                this.$toast(data.msg)
            }else{
                if (data.msg.indexOf('http')!==-1) {
                    this.$refs.investigationFrame.src = data.msg
                }else{
                    this.$toast(data.msg)
                }
            }
        });
    },
}

</script>